import Histogram from "./HistogramWrapper";

export default Histogram;
